<template>
  <div class="vv-progress-circle">
    <svg xmlns="http://www.w3.org/2000/svg" height="120" width="120" viewBox="0 0 200 200">
      <path
        stroke="#f1f1f1"
        d="M 100, 100 m 0,-75 a 75,75 0 0,1 0,150 a 75,75 0 0,1 0,-150"
        fill="none"
      />
      <path
        class="meter"
        d="M 100, 100 m 0,-75 a 75,75 0 0,1 0,150 a 75,75 0 0,1 0,-150"
        fill="none"
        :stroke="color || '#51da7e'"
        stroke-dasharray="471.305419921875"
        :stroke-dashoffset="offset"
      />
      <text
        x="50%"
        y="50%"
        dominant-baseline="middle"
        text-anchor="middle"
        class="percentage"
        :style="{ fill: this.color }"
      >
        {{ roundedPercentage }}%
      </text>
    </svg>
  </div>
</template>

<script>
// M 100, 100 m 0,-75 a 75,75 0 0,1 0,150 a 75,75 0 0,1 0,-150
// move to 100,100 absolute (middle of the circle)
// move to 0, -75 relative => goes on top of the cirlce
// draw an arc relative (from the top) to the same coordinate + 150 on y (0, 150)
// draw an arc relative (from the bottom, where we stopped on the last arc)
// to the same coordinate -150 on y (0, -150)

// 471.305419921875 is the path length and we move the offset to handle the progression
// we can obtain the path length by query selecting it and using:
// path.getTotalLength()

export default {
  name: 'vv-progress-circle',
  props: {
    percentage: Number,
    color: String
  },
  computed: {
    roundedPercentage() {
      return Math.round(this.percentage)
    },
    offset() {
      return 471.305419921875 * ((100 - this.percentage) / 100)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.vv-progress-circle {
  display: inline-block;

  svg path {
    fill: none;
    stroke-width: 16px;
    stroke-miterlimit: round;
    transition: stroke-dashoffset 850ms ease-in-out;
  }

  .percentage {
    font-size: 36px;
    font-weight: 900;
    fill: $secondary;
  }
}
</style>
